"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _Functions = require("../core/Functions");

var _colors = require("HubStyleTokens/colors");

var _Styles = require("../utils/Styles");

var _TileContext = require("../context/TileContext");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  right: 12px;\n  top: 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  ", ";\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* class needed here due to styled-components 3 bug */\n  .private-tile + & {\n    margin-top: 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var compactTileContext = {
  compact: true
};
var spacedMixin = (0, _styledComponents.css)(_templateObject());

var Tile = _styledComponents.default.div.withConfig({
  displayName: "UITile__Tile",
  componentId: "mv3mlg-0"
})(_templateObject2(), _Styles.setBorderRadius, _colors.OLAF, _colors.GREAT_WHITE, function (_ref) {
  var distance = _ref.distance;
  return distance && (0, _Styles.setDistance)(distance);
}, function (_ref2) {
  var distance = _ref2.distance;
  return !distance && spacedMixin;
});

var CloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UITile__CloseButton",
  componentId: "mv3mlg-1"
})(_templateObject3());

var UITile = _react.default.createClass({
  displayName: "UITile",
  propTypes: {
    children: _react.PropTypes.node.isRequired,
    closeable: _react.PropTypes.bool.isRequired,
    compact: _react.PropTypes.bool.isRequired,
    distance: _react.PropTypes.oneOf(_Styles.DISTANCE_KEYS),
    onClose: _react.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      compact: false
    };
  },
  handleCloseButtonClick: function handleCloseButtonClick(evt) {
    (0, _Functions.callIfPossible)(this.props.onClose, evt);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        closeable = _this$props.closeable,
        compact = _this$props.compact,
        __onClose = _this$props.onClose,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable", "compact", "onClose"]);
    return _react.default.createElement(_TileContext.TileContextProvider, {
      value: compact ? compactTileContext : _TileContext.defaultTileContext
    }, _react.default.createElement(Tile, (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)('private-tile', className)
    }), closeable ? _react.default.createElement(CloseButton, {
      color: _colors.FLINT,
      onClick: this.handleCloseButtonClick,
      size: "small"
    }) : null, children));
  }
});

var _default = UITile;
exports.default = _default;
module.exports = exports.default;